(function () {
  function getContainer(target) {
    return target.closest(".quick-add-drawer");
  }

  function getVariants(container) {
    try {
      const raw = container.getAttribute("data-variants");
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(container) {
    const wrappers = container.querySelectorAll("[data-option-index]");
    const selected = [];
    wrappers.forEach(function (w) {
      const idx = parseInt(w.getAttribute("data-option-index"));
      const radio = w.querySelector(
        'input[type="radio"][data-option-value-select]:checked'
      );
      const select = w.querySelector("select[data-option-dropdown]");
      let value = "";
      if (radio) value = radio.value;
      else if (select) value = select.value;
      selected[idx] = value;
    });
    return selected;
  }

  function findVariant(variants, options) {
    return (
      variants.find(function (v) {
        if (!v) return false;
        return v.options.every(function (opt, i) {
          return opt == options[i];
        });
      }) || null
    );
  }

  function updateButton(container, variant) {
    const btn = container.querySelector(".drawer-footer-button");
    const input =
      container.querySelector(
        '[name="id"].drawer-variant-id-' +
          container.getAttribute("data-product-id")
      ) || container.querySelector('[name="id"]');
    if (variant && input) input.value = variant.id;
    if (!btn) return;

    // Find the text span and cross span to preserve structure
    const textSpan = btn.querySelector("span:not([onclick])");
    const crossSpan = btn.querySelector("span[onclick]");

    if (!variant) {
      if (textSpan) textSpan.textContent = "Unavailable";
      btn.disabled = true;
      btn.style.opacity = "0.6";
      btn.style.cursor = "not-allowed";
      return;
    }
    if (variant.available) {
      if (textSpan) textSpan.textContent = "ADD TO CART";
      btn.disabled = false;
      btn.style.opacity = "1";
      btn.style.cursor = "pointer";
    } else {
      if (textSpan) textSpan.textContent = "SOLD OUT";
      btn.disabled = true;
      btn.style.opacity = "0.6";
      btn.style.cursor = "not-allowed";
    }
  }

  function updateSizeDesc(container) {
    const el = container.querySelector('[id^="size-description-"]');
    if (!el) return;
    const options = getSelectedOptions(container);
    const size = options[0];
    if (size && (size.includes("5") || size.includes("LBS"))) {
      el.textContent = "Save 15%";
      el.style.display = "block";
    } else {
      el.style.display = "none";
    }
  }

  document.addEventListener("change", function (e) {
    if (!e.target.closest(".quick-add-drawer")) return;
    if (!e.target.matches("[data-option-value-select], [data-option-dropdown]"))
      return;
    const container = getContainer(e.target);
    const variants = getVariants(container);
    const options = getSelectedOptions(container);
    const variant = findVariant(variants, options);
    updateButton(container, variant);
    updateSizeDesc(container);
  });

  window.initializeQuickAddDrawer = function (productId) {
    const container = document.getElementById("quick-add-drawer-" + productId);
    if (!container) return;
    const variants = getVariants(container);
    const options = getSelectedOptions(container);
    const variant = findVariant(variants, options);
    updateButton(container, variant);
    updateSizeDesc(container);
  };
})();
